
import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormField, FormItem, FormLabel, FormControl, FormDescription } from '@/components/ui/form';
import { Switch } from '@/components/ui/switch';
import { UseFormReturn } from 'react-hook-form';
import { FormValues } from '../schema/QuestFormSchema';

interface QuestStatusFieldProps {
  form: UseFormReturn<FormValues>;
}

const QuestStatusField: React.FC<QuestStatusFieldProps> = ({ form }) => {
  const { t } = useTranslation(['admin', 'common']);

  return (
    <FormField
      control={form.control}
      name="is_active"
      render={({ field }) => (
        <FormItem className="flex flex-row items-center justify-between pt-2">
          <div className="space-y-0.5">
            <FormLabel>{t('admin:questActive')}</FormLabel>
            <FormDescription>
              {t('admin:activeQuestDescription')}
            </FormDescription>
          </div>
          <FormControl>
            <Switch
              checked={field.value}
              onCheckedChange={field.onChange}
            />
          </FormControl>
        </FormItem>
      )}
    />
  );
};

export default QuestStatusField;
